module.exports = __webpack_public_path__ + "img/Master-Joda-icon.433c4552.png";